import { Anchor, Center, Container, Stack, Text } from "@mantine/core";
import { createFileRoute, Link, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/notAuthorized/$")({
  component: NotAuthorizedPage
});
function NotAuthorizedPage() {
  const page = useParams({ from: "/notAuthorized/$" });
  return (
    <Container strategy="grid" size={1150} className="pt-5">
      <Center>
        <Stack style={{ textAlign: "center" }}>
          <Text size="xl" mb={4}>
            You are not authorized to view the page {page._splat}.
          </Text>
          <Text>
            Click{" "}
            <Anchor component={Link} c="optimaBlue.7" to="/">
              here
            </Anchor>{" "}
            to return to the home page.
          </Text>
        </Stack>
      </Center>
    </Container>
  );
}
